var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoTitle02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 28828",
    d: "M4 0h3a12 12 0 0 1 12 12v15H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    transform: "translate(8 3)",
    style: {
      fill: "#ffe500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14210",
    d: "M27.5 19.173v-3.7a4.98 4.98 0 0 0-5.175-4.76h-2.3A1.66 1.66 0 0 1 18.3 9.125V7.01a4.98 4.98 0 0 0-5.175-4.76H10.25m0 17.981h11.5m-11.5 4.231H16M13.7 2.25H6.225A1.661 1.661 0 0 0 4.5 3.837v24.326a1.661 1.661 0 0 0 1.725 1.587h19.55a1.661 1.661 0 0 0 1.725-1.587V14.942c0-7.01-6.178-12.692-13.8-12.692z",
    transform: "translate(0 .25)",
    style: {
      fill: "none",
      stroke: "#1b1b1b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 28826",
    style: {
      fill: "#fff",
      opacity: 0.001
    },
    d: "M0 0h32v32H0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTitle02);
export default __webpack_public_path__ + "viewer/static/media/ico-title-02.bd5ccfeb74f9458d85be498819b8cc49.svg";
export { ForwardRef as ReactComponent };